export class ExcludeFromBackupResponse {
    'isExcluded';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "isExcluded",
            "baseName": "isExcluded",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExcludeFromBackupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
